import React, { useState } from "react";
import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  IconButton,
} from "@mui/material";
import { ChevronLeft } from "lucide-react";
import { api } from "../../api/api";
import { get_bank_otp_api, orderhistory_api } from "../../api/urls";
import { toast } from "react-toastify";

const StepRefundPayment = ({
  refundMethod,
  setRefundMethod,
  onNext,
  onBack,
  orderData,
  orderID,
  isReturn,
  setStep,
  cancelReason,
  additionalComments,
  setToken,
  selectedQty,
}) => {
  const [loading, setLoading] = useState(false);

  const handleTransferTo = (mode) => {
    switch (mode) {
      case "Original Payment Method":
        return "refund_to_source";
      case "TagOn Wallet":
        return "refund_to_wallet";
      default:
        break;
    }
  };

  const transferToKey = handleTransferTo(refundMethod);

  const payload = {
    reason_choices: cancelReason,
    reason_comment: additionalComments,
    quantity: selectedQty,
    cart_id: orderID,
    user_check: true,
    [transferToKey]: refundMethod !== "Credits" ? true : undefined,
  };

  const handleContinue = async () => {
    try {
      setLoading(true);

      if (refundMethod === "Add Bank Account" || refundMethod === "UPI ID") {
        const res = await api.post(get_bank_otp_api, {});
        setToken(res.data.token);
        setStep(4);
      } else {
        await api.patch(
          orderhistory_api +
            `${orderID}/${isReturn ? "returnproduct" : "cancelproduct"}/`,
          payload,
        );
        setStep(3);
      }
    } catch (error) {
      toast.error(error.response?.data?.data || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box
      sx={{
        // maxWidth: 600,
        minHeight: { xs: "70vh", sm: "60vh", md: "55vh" },
        maxHeight: "90vh",
        overflowY: "auto",
        p: 4,
        bgcolor: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* All content except the button */}
      <Box sx={{ flexGrow: 1 }}>
        {/* Back Button */}
        <button
          className="text-sm mt-2 flex items-center gap-1 text-gray-400 mb-2"
          onClick={onBack}
        >
          {/* <Typography fontSize="14px" fontWeight={500} sx={{ ml: 1 }}> */}
          <ChevronLeft size={20} /> Back
        </button>

        {/* Main Heading */}
        <Typography variant="h5" fontWeight={600} mb={1}>
          Refund Payment Method
        </Typography>

        <Typography fontWeight={600} fontSize="14px" mb={1}>
          Choose payment method
        </Typography>

        {/* <RadioGroup
          value={cancelReason}
          onChange={(e) => setCancelReason(e.target.value)}
          sx={{ mb: 4 }}
        >
          <FormControlLabel
            value="too_big"
            control={<Radio />}
            label="original payment method"
          />
        </RadioGroup> */}

        <RadioGroup
          value={refundMethod}
          onChange={(e) => setRefundMethod(e.target.value)}
        >
          {/* <FormControlLabel
            value="original"
            control={<Radio />}
            label="Original Payment Method"
          /> */}
          {isReturn && orderData.payment_method === "Cash On Delivery" ? (
            <>
              <FormControlLabel
                value={"Add Bank Account"}
                control={<Radio />}
                label={"Add Bank Account"}
              />
              <FormControlLabel
                value={"TagOn Wallet"}
                control={<Radio />}
                label={"TagOn Wallet"}
              />
              <FormControlLabel
                value={"UPI ID"}
                control={<Radio />}
                label={"UPI ID"}
              />
            </>
          ) : (
            orderData?.bank_structure?.map((d) => (
              <FormControlLabel
                key={d}
                value={d}
                control={<Radio />}
                label={d}
              />
            ))
          )}
        </RadioGroup>
      </Box>

      {/* Continue Button at the bottom */}
      <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
        <button
          onClick={handleContinue}
          disabled={!refundMethod || loading}
          className="disabled:bg-slate-200 disabled:text-slate-400 p-2 rounded-md cursor-pointer border px-5 hover:bg-black hover:text-white transition-all"
        >
          Continue
        </button>
      </Box>
    </Box>
  );
};

export default StepRefundPayment;
